import { useState } from "react"
import { useTranslation } from "react-i18next"
import classnames from "classnames"

import { config } from "@oysterhr/core"

import { Text, FormLabel, LoadingSpinner, TextInput, Button } from "@oysterhr/ui"

import { IbanElement } from "@stripe/react-stripe-js"

import useAddStripeSepaForm from "../../hooks/useAddStripeSepaForm"
import { ReusableWizard, useReusableWizard } from "@oysterhr/feature-components"

const SEPA = "SEPA"

export const BankAccountDetails = () => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/SepaFlow")
  const [ibanReady, setIbanReady] = useState(false)

  const { goToNext } = useReusableWizard()

  const {
    onSubmit,
    onIbanChange,
    handleSubmit,
    loading,
    register,
    formState: { errors },
    formIsReady,
  } = useAddStripeSepaForm({ onSuccess: goToNext })

  const isFormReady = ibanReady && formIsReady

  if (config.nonProductionEnvironment) {
    console.log("SEPA test account AT611904300234573201")
  }

  return (
    <ReusableWizard.Step title="Add payment method" subtitle="Next: Authorize Direct Debit">
      <div className="mt-8">
        <Text>{t("bankDetails.title")}</Text>
        <div>
          {!isFormReady && (
            <div className="flex justify-center" role="progressbar">
              <LoadingSpinner />
            </div>
          )}
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="mt-4">
              <TextInput
                {...register("name")}
                label={<FormLabel label={t("bankDetails.accountHolderName")} />}
                error={errors?.name?.message}
                disabled={!isFormReady}
              />
            </div>
            <div className="mt-4">
              <TextInput
                {...register("email")}
                label={<FormLabel label={t("bankDetails.email")} />}
                error={errors?.email?.message}
                disabled={!isFormReady}
              />
            </div>
            <div className="mt-4">
              <FormLabel label={t("bankDetails.iban")}></FormLabel>
              <div
                className={classnames("my-2 rounded-lg border-2 p-3", {
                  "border-gray-300 bg-white text-black": !errors?.iban?.message,
                  "border-error-base": errors?.iban?.message,
                  "bg-gray-100 text-gray-400": !isFormReady,
                })}
              >
                <IbanElement
                  options={{
                    supportedCountries: [SEPA],
                  }}
                  onReady={() => setIbanReady(true)}
                  onChange={onIbanChange}
                />
              </div>
              {errors?.iban?.message && (
                <div className="text-sm text-error-base">{errors?.iban?.message}</div>
              )}
            </div>
            <Button
              data-analytics-name="company_payment_methods-sepa-create-payment-method"
              className="mt-8"
              disabled={!isFormReady}
              isLoading={loading}
            >
              {t("submitButton")}
            </Button>
          </form>
        </div>
      </div>
    </ReusableWizard.Step>
  )
}
